import { queryKeys } from '@query/keys'
import { useQuery } from '@tanstack/react-query'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

export const useDepositMarginBonus = (
  tradingAccountId: string | undefined,
  campaignId: string | undefined,
  amount: number | undefined
) => {
  const clientApi = useApiClient(ClientApiClient)

  const { data: marginBonus, isLoading } = useQuery({
    queryKey: queryKeys.campaign.marginBonus(tradingAccountId, campaignId, amount),
    queryFn: () => clientApi.getMarginBonus(tradingAccountId, campaignId, amount),
    enabled: !!tradingAccountId && !!campaignId && !!amount && amount > 0,
  })

  return { marginBonus, isLoading }
}
